import React, { Component } from 'react';
import { Button, Form, FormGroup, Label, Input, Row, Col } from 'reactstrap';
import { withApollo } from 'react-apollo';
import { CLEAR_BOX } from '../../mutation/mutation';

class ClearBox extends Component {

  constructor(props) {
    super(props);

    this.state = {
      boxId: '',
    };
    this.clearBox = this.clearBox.bind(this);
    this.changeBoxId = this.changeBoxId.bind(this);
  }

  clearBox() {
    this.props.client.mutate({
      mutation: CLEAR_BOX,
      variables: {
        boxId: this.state.boxId,
      },
    }).then(() => {
      this.props.refresh();
    }).catch((err) => {
      console.log('catch', err);
    });
  }

  changeBoxId(e) {
    this.setState({
      boxId: e.target.value,
    });
    setTimeout(() => { console.log(this.state.boxId); }, 100);
  }

  render() {
    return (
      <div>
        <hr />
        <Form onSubmit={this.handleAdd}>
          <FormGroup>
            <Label>Box token</Label>
            <Row>
              <Col>
                <Input
                  type="text"
                  value={this.state.boxId}
                  onChange={this.changeBoxId}
                />
              </Col>
              <Col>
                <Button
                  type="submit"
                  color="danger"
                  onClick={this.clearBox}>
                Effacer senders
                </Button>
              </Col>
            </Row>
          </FormGroup>
        </Form>
      </div>
    );
  }
}

export default withApollo(ClearBox);



// WEBPACK FOOTER //
// ./src/components/admin/clear-box.js